import { supabase } from '../lib/supabase';

// Estados brasileiros
export const ESTADOS_BRASIL = [
  'Acre', 'Alagoas', 'Amapá', 'Amazonas', 'Bahia', 'Ceará', 'Distrito Federal',
  'Espírito Santo', 'Goiás', 'Maranhão', 'Mato Grosso', 'Mato Grosso do Sul',
  'Minas Gerais', 'Pará', 'Paraíba', 'Paraná', 'Pernambuco', 'Piauí',
  'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondônia',
  'Roraima', 'Santa Catarina', 'São Paulo', 'Sergipe', 'Tocantins'
];

// Função para formatar tamanho do arquivo
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Função para obter o tipo de arquivo baseado na extensão
export const getFileType = (fileName) => {
  const extension = fileName.split('.').pop().toLowerCase();
  const types = {
    pdf: 'PDF',
    doc: 'Word',
    docx: 'Word',
    xls: 'Excel',
    xlsx: 'Excel',
    ppt: 'PowerPoint',
    pptx: 'PowerPoint',
    txt: 'Texto',
    jpg: 'Imagem',
    jpeg: 'Imagem',
    png: 'Imagem',
    gif: 'Imagem',
    webp: 'Imagem',
    mp4: 'Vídeo',
    mpeg: 'Vídeo',
    mov: 'Vídeo',
    avi: 'Vídeo',
    mp3: 'Áudio',
    wav: 'Áudio',
    ogg: 'Áudio'
  };
  return types[extension] || 'Arquivo';
};

// Buscar todos os conteúdos com informações das matérias e anos escolares
export const fetchConteudos = async () => {
  try {
    const { data, error } = await supabase
      .from('conteudos')
      .select(`
        *,
        materias:materia_id (
          id,
          nome
        ),
        anos_escolares:ano_escolar_id (
          id,
          nome
        )
      `)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Erro ao buscar conteúdos:', error);
    throw error;
  }
};

// Buscar matérias
export const fetchMaterias = async () => {
  try {
    const { data, error } = await supabase
      .from('materias')
      .select('*')
      .order('nome');

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Erro ao buscar matérias:', error);
    throw error;
  }
};

// Buscar anos escolares
export const fetchAnosEscolares = async () => {
  try {
    const { data, error } = await supabase
      .from('anos_escolares')
      .select('*')
      .order('nome');

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Erro ao buscar anos escolares:', error);
    throw error;
  }
};

// Upload de arquivo para o storage
export const uploadFile = async (file, fileName) => {
  try {
    const fileExt = file.name.split('.').pop();
    const filePath = `${Date.now()}-${fileName}.${fileExt}`;

    const { data, error } = await supabase.storage
      .from('conteudos')
      .upload(filePath, file);

    if (error) throw error;

    // Obter URL pública do arquivo
    const { data: publicUrlData } = supabase.storage
      .from('conteudos')
      .getPublicUrl(filePath);

    return {
      path: filePath,
      url: publicUrlData.publicUrl
    };
  } catch (error) {
    console.error('Erro ao fazer upload do arquivo:', error);
    throw error;
  }
};

// Criar novo conteúdo
export const createConteudo = async (conteudoData, file) => {
  try {
    let arquivo_url = null;
    let arquivo_nome = null;
    let arquivo_tamanho = null;
    let arquivo_tipo = null;

    // Se há arquivo, fazer upload
    if (file) {
      const uploadResult = await uploadFile(file, conteudoData.nome);
      arquivo_url = uploadResult.url;
      arquivo_nome = file.name;
      arquivo_tamanho = file.size;
      arquivo_tipo = file.type;
    }

    const { data, error } = await supabase
      .from('conteudos')
      .insert([{
        nome: conteudoData.nome,
        materia_id: conteudoData.materia_id,
        ano_escolar_id: conteudoData.ano_escolar_id,
        estado: conteudoData.estado,
        arquivo_url,
        arquivo_nome,
        arquivo_tamanho,
        arquivo_tipo
      }])
      .select();

    if (error) throw error;
    return data[0];
  } catch (error) {
    console.error('Erro ao criar conteúdo:', error);
    throw error;
  }
};

// Atualizar conteúdo
export const updateConteudo = async (id, conteudoData, file) => {
  try {
    let updateData = {
      nome: conteudoData.nome,
      materia_id: conteudoData.materia_id,
      ano_escolar_id: conteudoData.ano_escolar_id,
      estado: conteudoData.estado
    };

    // Se há novo arquivo, fazer upload
    if (file) {
      const uploadResult = await uploadFile(file, conteudoData.nome);
      updateData.arquivo_url = uploadResult.url;
      updateData.arquivo_nome = file.name;
      updateData.arquivo_tamanho = file.size;
      updateData.arquivo_tipo = file.type;
    }

    const { data, error } = await supabase
      .from('conteudos')
      .update(updateData)
      .eq('id', id)
      .select();

    if (error) throw error;
    return data[0];
  } catch (error) {
    console.error('Erro ao atualizar conteúdo:', error);
    throw error;
  }
};

// Deletar conteúdo
export const deleteConteudo = async (id, arquivoUrl) => {
  try {
    // Se há arquivo, deletar do storage
    if (arquivoUrl) {
      const fileName = arquivoUrl.split('/').pop();
      await supabase.storage
        .from('conteudos')
        .remove([fileName]);
    }

    const { error } = await supabase
      .from('conteudos')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Erro ao deletar conteúdo:', error);
    throw error;
  }
};

// Incrementar contador de downloads
export const incrementDownload = async (id) => {
  try {
    const { error } = await supabase
      .rpc('increment_download_count', { conteudo_id: id });

    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Erro ao incrementar download:', error);
    throw error;
  }
};
